import { uncoveredSalesChannelWarningSchema } from "@redotech/redo-model/sales-channels";
import * as z from "zod";

export const getUncoveredSalesChannelWarnings = {
  name: "getUncoveredSalesChannelWarnings" as const,
  input: z.object({}),
  output: z.object({ warnings: z.array(uncoveredSalesChannelWarningSchema) }),
};

export { uncoveredSalesChannelWarningSchema } from "@redotech/redo-model/sales-channels";
